/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.svg-reveal' ).each( function() {
        gsap.set( $( this ).find( 'svg' ), {overflow: 'visible'} );
        const heroDots = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top bottom',
            pin: false,
            scrub: false,
            // markers: true,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
          },
        } );
        heroDots.from( $( this ).find( 'svg path' ), {
          scale: 1.2,
          opacity: 0,
          rotate: '-10deg',
          stagger: 0.05,
          x: 20,
          duration: .25,
        } );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'error-page', COMPONENT );
} )( app );
